import { configureStore } from '@reduxjs/toolkit'
import { serviceApi } from '../Services/serviceApi'
import { setupListeners } from '@reduxjs/toolkit/query'

export const store = configureStore({
    reducer: {
      [serviceApi.reducerPath]:serviceApi.reducer,
    },
    middleware:(getDefaultMiddleware)=> getDefaultMiddleware().concat(serviceApi.middleware)
    
  })
  
  setupListeners(store.dispatch)